import React, { useEffect } from 'react';
import VendorAccountSetupStepLayoutStyled from './VendorAccountSetupStepLayout.styled';
import { newPageTrigger } from 'LivePerson';

function VendorAccountSetupStepLayout(props) {
    const {
        header,
        formComponent,
        footer,
        compactScroll,
        compactWelcomeHeader,
        topOffset = 0,
        noFooterSpace = false,
        compactHeader = false,
    } = props;

    useEffect(() => {
        newPageTrigger(window.location.href);
    }, [window.location.href]);

    return (
        <VendorAccountSetupStepLayoutStyled
            $compactScroll={compactScroll}
            $compactWelcomeHeader={compactWelcomeHeader}
            $topOffset={topOffset}
            $noFooterSpace={noFooterSpace}
            $compactHeader={compactHeader}
        >
            <div className="rightSide">
                <div className="innerRight">
                    <div
                        className={
                            compactWelcomeHeader ? 'stepHeader welcomeTrialHeader' : 'stepHeader'
                        }
                    >
                        {header}
                    </div>
                    <main className="stepComponent">
                        <div className="formWrapper">{formComponent}</div>
                    </main>
                </div>
                {footer}
            </div>
        </VendorAccountSetupStepLayoutStyled>
    );
}

export { VendorAccountSetupStepLayout };
